function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* ========================================================================
 * Apricot's Input Mask Module
 * ======================================================================== */

// SCSS
import "../scss/includes/input-mask.scss";

// javaScript
import Utils from "./CBUtils";

// ------------------------------------  INPUT MASK
/**
 * Input Mask
 *
 * @export
 * @param {Object} data
 * @param {Element} data.elem
 * @param {String} data.cbPlaceholder
 * @param {String} data.cbMask
 * @param {String} data.cbChar
 * @param {String} data.cbNum
 * @returns {{destroy: Function}}
 *
 */
var InputMask = function InputMask() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultData = {
    elem: null,
    cbPlaceholder: null,
    cbMask: null,
    cbChar: "_",
    cbNum: "#xXdDmMyY9"
  };
  var elem = data.elem;
  if (!Utils.elemExists(elem)) return false;
  var tmp = elem.dataset;
  data = _objectSpread(_objectSpread({}, defaultData), data);
  data = _objectSpread(_objectSpread({}, data), tmp);
  var cbMask = data.cbMask;
  var cbPlaceholder = data.cbPlaceholder;
  var _char = data.cbChar;
  var num = data.cbNum;
  var cursorPosition = 0; // Store the cursor position

  var init = function init() {
    elem.inputMaskPlugin = "cb";
    if (cbPlaceholder) {
      Utils.attr(elem, "placeholder", cbPlaceholder);
      Utils.attr(elem, "maxlength", cbPlaceholder.length);
    }
    elem.addEventListener("input", handleValueChange);
    // Remember cursor position on keydown
    elem.addEventListener("keydown", rememberCursorPosition);
  };
  var handleValueChange = function handleValueChange(e) {
    var _e$target = e.target,
      value = _e$target.value,
      selectionStart = _e$target.selectionStart,
      selectionEnd = _e$target.selectionEnd;
    if (value.length > 0 && e.inputType !== "deleteContentBackward") {
      var newValue = setValue(e);
      var diff = newValue.length - value.length;
      var adjustedCursorStart = selectionStart + diff;
      var adjustedCursorEnd = selectionEnd + diff;
      elem.value = newValue;
      var newStart = Math.min(adjustedCursorStart, newValue.length);
      var newEnd = Math.min(adjustedCursorEnd, newValue.length);
      elem.setSelectionRange(newStart, newEnd);
    }
  };
  var setValue = function setValue(e) {
    var placeholder = cbMask || cbPlaceholder;
    var value = e.target.value;
    var newValue = "";
    var strippedValue = "";
    var isInt = false;
    var isLetter = false;
    var matchesNumber = false;
    var matchesLetter = false;

    // strip special characters
    strippedValue = cbMask ? value.replace(/\W/g, "") : value.replace(/\D/g, "");
    for (var i = 0, j = 0; i <= placeholder.length; i++) {
      if (placeholder[i] === undefined) break;
      isInt = !isNaN(parseInt(strippedValue[j]));
      isLetter = strippedValue[j] ? strippedValue[j].match(/[A-Z]/i) : false;
      matchesNumber = num.indexOf(placeholder[i]) >= 0;
      matchesLetter = _char.indexOf(placeholder[i]) >= 0;
      switch (true) {
        case matchesNumber && isInt:
          newValue += strippedValue[j++];
          break;
        case !cbMask && !isInt && matchesNumber:
        case cbMask && (matchesLetter && !isLetter || matchesNumber && !isInt):
          return newValue;
        default:
          newValue += placeholder[i];
      }
      if (strippedValue[j] === undefined) {
        break;
      }
    }
    return newValue;
  };
  var rememberCursorPosition = function rememberCursorPosition(e) {
    cursorPosition = e.target.selectionStart;
  };
  var destroy = function destroy() {
    if (elem.inputMaskPlugin === "cb") {
      elem.inputMaskPlugin = null;
    }
    Utils.removeAttr(elem, "maxlength");
    elem.removeEventListener("input", handleValueChange);
    elem.removeEventListener("keydown", rememberCursorPosition);
  };
  if (elem.inputMaskPlugin !== "cb") {
    init();
  }
  return {
    destroy: destroy
  };
};
export default InputMask;